<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="领取用户">
                <el-input v-model="queryForm.userId"></el-input>
            </el-form-item>
            <el-form-item label="领取金额">
                <el-input v-model="queryForm.amount"></el-input>
            </el-form-item>

            <el-form-item label="领取红包">
                <el-input v-model="queryForm.redPacketId"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopRedPacketRecordList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopRedPacketRecord">新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopRedPacketRecord(null)"
                        >修改</el-button
                    >
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopRedPacketRecord(null)"
                        >删除</el-button
                    > -->
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>

                    <span class="icon-box" @click="refreshShopRedPacketRecordList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopRedPacketRecordList"
                row-key="id"
                border
                :header-row-style="{ height: '10px' }"
                :header-cell-style="{ padding: '10px' }"
                :row-style="{ height: '9px' }"
                :cell-style="{ padding: '9px' }"
                @selection-change="handleSelectionChange"
                size="small"
                height='100'
            >
                <el-table-column align="center" type="selection" width="60"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="领取用户" width="">
                    <template slot-scope="scope">
                        <div v-if="scope.row.user">
                            {{ scope.row.user.userName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="amount" label="领取金额" width=""> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="redpacketId" label="领取红包" width="">
                </el-table-column>

                <el-table-column fixed="right" align="center" label="操作" width="300">
                    <template slot-scope="scop">
                        <div class="operation">
                            <!-- <div @click="checkShopRedPacketRecord(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopRedPacketRecord(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div> -->
                            <div @click="deleteShopRedPacketRecord(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopRedPacketRecordStates[shopRedPacketRecordState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopRedPacketRecord"
                        ref="shopRedPacketRecordForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item label="" prop="id">
                            <el-input
                                size="small"
                                v-model="shopRedPacketRecord.id"
                                :disabled="shopRedPacketRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="领取用户" prop="userId">
                            <el-input
                                size="small"
                                v-model="shopRedPacketRecord.userId"
                                :disabled="shopRedPacketRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="领取金额" prop="amount">
                            <el-input
                                size="small"
                                v-model="shopRedPacketRecord.amount"
                                :disabled="shopRedPacketRecordState == 'check'"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="领取的红包id" prop="redPacketId">
                            <el-input
                                size="small"
                                v-model="shopRedPacketRecord.redPacketId"
                                :disabled="shopRedPacketRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="createTime">
                            <el-input
                                size="small"
                                v-model="shopRedPacketRecord.createTime"
                                :disabled="shopRedPacketRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="updateTime">
                            <el-input
                                size="small"
                                v-model="shopRedPacketRecord.updateTime"
                                :disabled="shopRedPacketRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="createUserId">
                            <el-input
                                size="small"
                                v-model="shopRedPacketRecord.createUserId"
                                :disabled="shopRedPacketRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="updateUserId">
                            <el-input
                                size="small"
                                v-model="shopRedPacketRecord.updateUserId"
                                :disabled="shopRedPacketRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="deleteFlag">
                            <el-input
                                size="small"
                                v-model="shopRedPacketRecord.deleteFlag"
                                :disabled="shopRedPacketRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="shopRedPacketRecordState != 'check'">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopRedPacketRecordList();
                this.getShopRedPacketRecordList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopRedPacketRecordList();
                this.getShopRedPacketRecordList();
                this.$emit('resetCheckState');
            }
        }
    },
    props:{
        redPacketId:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            queryForm: {
                amount: '', //领取金额
                userId: '', //领取用户
                redPacketId: '' //领取的红包id
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopRedPacketRecordState: 'add',
            shopRedPacketRecordStates: {
                add: '新建shop_red_packet_record',
                check: '查看shop_red_packet_record',
                edit: '修改shop_red_packet_record'
            },

            multipleSelection: [],
            shopRedPacketRecordList: [],
            shopRedPacketRecord: {
                id: '', //
                amount: '', //领取金额
                userId: '', //领取用户
                redPacketId: '', //领取的红包id
                createTime: '', //
                updateTime: '', //
                createUserId: '', //
                updateUserId: '', //
                deleteFlag: '' //
            },
            btnLoading: false,

            rules: {
                id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                amount: [{ required: true, message: '领取金额不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '领取用户不能为空', trigger: 'blur' }],
                redPacketId: [{ required: true, message: '领取的红包id不能为空', trigger: 'blur' }],
                createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                updateTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                createUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                updateUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                deleteFlag: [{ required: true, message: '不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {

    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopRedPacketRecordList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopRedPacketRecordList = [];
        },
        resetDialog() {
            this.shopRedPacketRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                id: '', //
                amount: '', //领取金额
                userId: '', //领取用户
                redPacketId: '', //领取的红包id
                createTime: '', //
                updateTime: '', //
                createUserId: '', //
                updateUserId: '', //
                deleteFlag: '' //
            };
            this.getShopRedPacketRecordList();
        },
        closeDialog() {
            this.shopRedPacketRecord = {
                id: '', //
                amount: '', //领取金额
                userId: '', //领取用户
                redPacketId: '', //领取的红包id
                createTime: '', //
                updateTime: '', //
                createUserId: '', //
                updateUserId: '', //
                deleteFlag: '' //
            };
        },
        submitForm() {
            if (this.shopRedPacketRecordState == 'add') {
                this.$refs.shopRedPacketRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/shopredpacketrecord/add`, { ...this.shopRedPacketRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopRedPacketRecordList();
                                this.resetDialog();
                                this.getShopRedPacketRecordList();
                            }
                        });
                    }
                });
            } else if (this.shopRedPacketRecordState == 'edit') {
                this.$refs.shopRedPacketRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/shopredpacketrecord/edit`, { ...this.shopRedPacketRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopRedPacketRecordList();
                                this.resetDialog();
                                this.getShopRedPacketRecordList();
                            }
                        });
                    }
                });
            }
        },
        addShopRedPacketRecord() {
            this.showDialog = true;
            this.shopRedPacketRecordState = 'add';
        },
        checkShopRedPacketRecord(shopRedPacketRecordId) {
            console.log(shopRedPacketRecordId);
            this.currentShopRedPacketRecordId = shopRedPacketRecordId;

            this.getShopRedPacketRecordById();
            this.showDialog = true;
            this.shopRedPacketRecordState = 'check';
        },
        editShopRedPacketRecord(shopRedPacketRecordId) {
            console.log('shopRedPacketRecord', shopRedPacketRecordId);
            if (shopRedPacketRecordId) {
                this.currentShopRedPacketRecordId = shopRedPacketRecordId;
                this.getShopRedPacketRecordById();
            } else {
                this.shopRedPacketRecord = { ...this.shopRedPacketRecord, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopRedPacketRecordState = 'edit';
        },
        deleteShopRedPacketRecord(shopRedPacketRecordId) {
            let ids = '';
            if (shopRedPacketRecordId) {
                ids = shopRedPacketRecordId;
            } else {
                ids = this.multipleSelection.map((shopRedPacketRecord) => shopRedPacketRecord.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/shopredpacketrecord/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopRedPacketRecordList();
                            this.getShopRedPacketRecordList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopRedPacketRecordList() {
            this.resetShopRedPacketRecordList();
            this.getShopRedPacketRecordList();
        },
        getShopRedPacketRecordList(query = {}) {
            this.loading = true;
            get(`/shop/shopredpacketrecord/findList`, { ...this.queryForm, redpacketId: this.redPacketId,pageNum: this.currentPage, pageSize: this.pageSize }).then(
                (res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopRedPacketRecordList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                }
            );
        },
        getShopRedPacketRecordById() {
            get(`/mpp/shopredpacketrecord/get`, { id: this.currentShopRedPacketRecordId }).then((res) => {
                if (res.success) {
                    this.shopRedPacketRecord = { ...this.shopRedPacketRecord, ...res.shopRedPacketRecord };
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopRedPacketRecordList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/shopredpacketrecord/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/shopredpacketrecord/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/shopredpacketrecord/importData`, formData);
            this.refreshShopRedPacketRecordList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopRedPacketRecordList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopRedPacketRecordList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
